<template>
  <section v-if="componentLoan">
    <v-layout justify-center>
      <v-progress-circular
        :value="investingPercent"
        width="10"
        color="primary"
        size="240"
        rotate="-90"
      >
        <div class="black--text text-center">
          <p class="color--nice-grey mb-1">모집중</p>
          <h1 class="font-size--24 mb-1">{{ commaFormat(investingAmount) }} 원</h1>
          <p v-if="componentLoan">/{{ commaFormat(componentLoan.amount) }} 원</p>
        </div>
      </v-progress-circular>
    </v-layout>
  </section>
</template>

<script>
import { commaFormat } from '@/filter/number'
import { mapActions } from 'vuex'
export default {
  props: ['loanUuid', 'loan'],
  data() {
    return {
      componentLoan: null,
      investingAmount: 0,
    }
  },
  computed: {
    /**
     * 모집 몇 퍼센트 완료됐는지
     */
    investingPercent() {
      if (!this.loan || !this.investingAmount) return 0
      return ((this.investingAmount / this.componentLoan.amount) * 100).toFixed(0)
    },
  },

  async created() {
    this.componentLoan = this.loan
    this.investingAmount = (await this.getInvestingAmount(this.loanUuid)) || 0

    if (!this.componentLoan) {
      this.componentLoan = await this.getLoansDetail(this.loanUuid)
    }
  },

  methods: {
    ...mapActions('loan', ['getLoansDetail', 'getInvestingAmount']),
    commaFormat,
  },
}
</script>

<style lang="scss" scoped></style>
